import { Component, Input, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../../tpv/services";
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { CompCreateTablePage } from '../../../../components/popups/create-table/create-table';

/**
 * Generated class for the ConfigurationPartialRoomsCreateListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-partial-rooms-create-list',
    templateUrl: 'configuration-partial-rooms-create-list.html',
})
export class ConfigurationPartialRoomsCreateListPage {

    @Input() room;
    @Input() update_state: boolean = false;

    @Input() form: FormGroup;
    public form_table: FormGroup;
    public room_uid: any;
    public table: any;
    public room_name: any;
    public order: any;
    map: boolean = false;
    editable_table: any;
    all_tables_insert: boolean = false;
    //datatable
    @ViewChild(DatatableComponent) datatable: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        public tpvServices: TPVServices,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public modalCtrl: ModalController) {

    }
    ngOnInit() {
        let index_room = this.tpvServices.rooms_panels.findIndex(x => x.UID == this.room.UID);
        let total_tables_insert = this.tpvServices.rooms_panels[index_room].content.filter(x => x.map_insert === undefined || x.map_insert === true);
        if (total_tables_insert.length === this.tpvServices.rooms_panels[index_room].content.length) {
            this.all_tables_insert = true;
        }
    }

    createTable() {
        let profileModal = this.modalCtrl.create(CompCreateTablePage, { table: [], room: this.room, update: false });
        profileModal.present();
    }

    clickElement(event) {
        if (event.type == 'click') {
            if (event.column.name == "in_map") {
                //Añadir o quitar del mapa
                let index_room = this.tpvServices.rooms_panels.findIndex(x => x.UID == this.room.UID);
                let index_table = this.tpvServices.rooms_panels[index_room].content.findIndex(x => x.UID == event.row.UID);
                if (event.row.map_insert == undefined || event.row.map_insert == true) {
                    this.tpvServices.rooms_panels[index_room].content[index_table].map_insert = false;
                } else {
                    this.tpvServices.rooms_panels[index_room].content[index_table].map_insert = true;
                }
                //Check si todas las mesas añadidas
                let total_tables_insert = this.tpvServices.rooms_panels[index_room].content.filter(x => x.map_insert === undefined || x.map_insert === true);
                if (total_tables_insert.length === this.tpvServices.rooms_panels[index_room].content.length) {
                    this.all_tables_insert = true;
                } else {
                    this.all_tables_insert = false;
                }
            } else {
                let profileModal = this.modalCtrl.create(CompCreateTablePage, { table: event.row, room: this.room, update: true });
                profileModal.present();
            }
        }
    }

    addAllTables(add) {
        let index_room = this.tpvServices.rooms_panels.findIndex(x => x.UID == this.room.UID);
        if (add) {
            this.tpvServices.rooms_panels[index_room].content.forEach(table => {
                table.map_insert = true;
                this.all_tables_insert = true;
            });
        } else {
            this.tpvServices.rooms_panels[index_room].content.forEach(table => {
                table.map_insert = false;
                this.all_tables_insert = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rooms/configuration-rooms-create/configuration-partial-rooms-create-list/configuration-partial-rooms-create-list.ts